export function generateRecipientList(transactionData, beneData) {
  const {
    beneficiary_name,
    gross_source_amount,
    source_currency,
    destination_amount,
    destination_currency,
    bank_name,
    bank_account_number,
    reason_for_transfer_text,
    reason_for_transfer_text_trade_code,
    net_source_amount,
    name,
    currency_code,
    bank_details,
    account_type,
    card_number,
    card_expiry_date,
    card_holder_name,
    card_issuer_name
  } = beneData;
  return {
    beneficiaryDetailsWithTempId: {},
    payload: { ...transactionData },
    beneficiaryDataToBeShown: {
      name: beneficiary_name || name,
      send_amt: gross_source_amount + ' ' + source_currency,
      receive_amt: destination_amount + ' ' + destination_currency,
      reason: reason_for_transfer_text,
      you_pay: net_source_amount + ' ' + source_currency,
      bank_details: {
        account_no: bank_account_number || (bank_details ? bank_details.account_no : ''),
        bank: bank_name || (bank_details ? bank_details.bank : '')
      },
      card_details: {
        card_no: card_number || '',
        card_expiry: card_expiry_date || '',
        card_holder_name: card_holder_name || '',
        card_issuer_name: card_issuer_name || ''
      },
      gross_source_amount,
      source_currency,
      destination_amount,
      destination_currency,
      net_source_amount,
      notes: transactionData.notes
    },
    beneficiary_id: transactionData.beneficiary_id,
    additionalDataForRL: {
      currency_code: currency_code || destination_currency,
      bene_account_type: account_type || transactionData.account_type,
      reason_for_transfer_text_trade_code
    }
  };
}

export function generatePayloadToSubmitBatch(recipientList, batch_number) {
  const data = [];
  if (batch_number) recipientList = recipientList.filter((item) => !item.temp_transaction_id);
  recipientList.forEach(({ payload, beneficiaryDataToBeShown }) => {
    const newItem = { ...payload };
    newItem.notes = beneficiaryDataToBeShown.notes || '';
    delete newItem.fx_rate_last_updated;
    delete newItem.transaction_config;
    delete newItem.country_code;
    data.push(newItem);
  });
  return data;
}

export function combineTempIdWithDetails(recipientList, recipientListWithTempId, tempTxnId) {
  const data = [];
  recipientListWithTempId.forEach((item, index) => {
    const recipientData = { ...recipientList[index] };
    recipientData.beneficiaryDataToBeShown = recipientList[index].beneficiaryDataToBeShown;
    recipientData.beneficiaryDetailsWithTempId = item;
    recipientData.temp_transaction_id = item.temp_transaction_id || tempTxnId;
    data.push(recipientData);
  });
  return data;
}

export function deleteRecipientTransactionFromList(recipientList, tempTxnId, index) {
  if (tempTxnId) index = recipientList.findIndex((x) => x.temp_transaction_id === tempTxnId);
  delete recipientList[index];
  recipientList = recipientList.filter((x) => x);
  return recipientList;
}

export function editRecipientListWith({
  recipientListFromRedux,
  currentRecipientData,
  saveData,
  tempTxnId,
  index
}) {
  if (tempTxnId) {
    index = recipientListFromRedux.findIndex((x) => x.temp_transaction_id === tempTxnId);
    recipientListFromRedux[index] = currentRecipientData;
    recipientListFromRedux[index].beneficiaryDetailsWithTempId = saveData[0];
    recipientListFromRedux[index].temp_transaction_id = tempTxnId;
  } else recipientListFromRedux[index] = currentRecipientData;
  return recipientListFromRedux;
}

export function getBatchNumber(recipientList) {
  const recipientListLength = recipientList.length;
  let batch_number = 0;
  if (recipientListLength > 0 && recipientList[0].beneficiaryDetailsWithTempId) {
    const beneDataWithTempId = recipientList[0].beneficiaryDetailsWithTempId;
    if (Object.keys(beneDataWithTempId).length > 0 && beneDataWithTempId.batch_number) {
      batch_number = beneDataWithTempId.batch_number;
    }
  }
  return batch_number;
}

export function getInfoContentConfig(
  configFor,
  {
    source_currency,
    source_amount,
    gross_source_amount,
    destination_currency,
    destination_amount,
    instarem_fx_rate,
    transaction_fee_amount,
    net_source_amount,
    totalYouSendAmt,
    totalYouPayAmount,
    totalConversionAmt,
    totalTransactionFeeAmount,
    totalTaxAmt
  }
) {
  const conversion_amt = source_amount - transaction_fee_amount;
  let config = null;
  totalYouSendAmt = Number(totalYouSendAmt || 0).toFixed(2);
  switch (configFor) {
    case 'source':
      config = [
        {
          title: 'You send',
          value: `${source_amount} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: ''
        },
        {
          title: 'Transaction fee',
          value: `-  ${transaction_fee_amount} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'brand-blue-color',
          parentClassName: ''
        },
        {
          title: 'Conversion amount',
          value: `${conversion_amt} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: 'dark-top-border'
        }
      ];
      break;
    case 'destination':
      config = [
        {
          title: 'Conversion amount',
          value: `${conversion_amt} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: ''
        },
        {
          title: `Conversion rate ${source_currency}/${destination_currency}`,
          value: 'X ' + instarem_fx_rate,
          titleClassName: 'brand-blue-color',
          valueClassName: 'brand-blue-color',
          parentClassName: ''
        },
        {
          title: 'Recipient receives',
          value: `${destination_amount} ${destination_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: 'dark-top-border'
        }
      ];
      break;
    case 'multi-recipient-list':
      config = [
        {
          title: 'You send',
          value: `${gross_source_amount} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: '',
          note: `includes fees of ${transaction_fee_amount} ${source_currency}`
        },
        {
          title: 'Recipient receives',
          value: `${destination_amount} ${destination_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: '',
          note: `@1 ${source_currency} = ${instarem_fx_rate + ' ' + destination_currency}`
        },
        {
          title: 'You pay',
          value: `${net_source_amount} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: 'dark-top-border'
        }
      ];
      break;
    case 'multi-total-amount':
      config = [
        {
          title: 'Total conversion amount',
          value: `${totalConversionAmt.toFixed(2)} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'brand-blue-color',
          parentClassName: ''
        },
        {
          title: 'Total transaction fee',
          value: `+ ${totalTransactionFeeAmount} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'brand-blue-color',
          parentClassName: ''
        },
        {
          title: 'Total you send',
          value: `${totalYouSendAmt} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: 'light-top-border'
        },
        {
          title: 'Total tax',
          value: `+ ${totalTaxAmt} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'brand-blue-color',
          parentClassName: ''
        },
        {
          title: 'Total payable amount',
          value: `${totalYouPayAmount.toFixed(2)} ${source_currency}`,
          titleClassName: 'brand-blue-color',
          valueClassName: 'normal-blue-color',
          parentClassName: 'dark-top-border'
        }
      ];
      break;
    case 'multi-ack-recipient-list':
      break;
    case 'multi-ack-total-amount':
      break;
    default:
      return config;
  }
  return config;
}
